export default __webpack_public_path__ + "static/media/ESSK34TANZ01_1920x1080.bc8fd32b.jpg";